<template>
	<vs-navbar class="vx-navbar navbar-skelton mb-base" type="fund">
		<div slot="title">
			<vs-navbar-title>
				<div class="flex flex-row justify-start items-center">
					<transition name="fade">
						<vx-tooltip delay=".1s" :text="$t('Remove') + ' ' + $t('DrawingTools.Selection')">
							<vs-button
								size="large"
								v-show="selected"
								@click="handleOption('CLEAR_SELECTION')"
								icon-pack="feather"
								icon="icon-x-square"
								color="danger"
								type="flat"
								radius
							></vs-button>
						</vx-tooltip>
					</transition>
					<span v-show="selected" class="ml-2">1 {{ $t("DrawingTools.Selection") }}</span>
				</div>
			</vs-navbar-title>
		</div>
		<!-- SM - OPEN SIDEBAR BUTTON -->
		<feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" />
		<vx-tooltip delay=".1s" :text="$t('Crud.Create')">
			<vs-button
				size="large"
				@click="handleOption('CREATE')"
				icon-pack="feather"
				icon="icon-plus-square"
				color="dark"
				type="flat"
				radius
			></vs-button>
		</vx-tooltip>
		<transition name="fade">
			<vx-tooltip delay=".1s" :text="$t('Crud.Update')">
				<vs-button
					size="large"
					v-show="selected"
					@click="handleOption('UPDATE')"
					icon-pack="feather"
					icon="icon-edit"
					color="dark"
					type="flat"
					radius
				></vs-button>
			</vx-tooltip>
		</transition>
		<transition name="fade">
			<vx-tooltip delay=".1s" :text="$t('Crud.Delete')">
				<vs-button
					size="large"
					v-show="selected"
					@click="handleOption('DELETE')"
					icon-pack="feather"
					icon="icon-trash-2"
					color="danger"
					type="flat"
					radius
				></vs-button>
			</vx-tooltip>
		</transition>
		<vs-dropdown vs-trigger-click>
			<vs-button
				size="large"
				icon-pack="feather"
				icon="icon-more-vertical"
				color="dark"
				type="flat"
				radius
			></vs-button>

			<vs-dropdown-menu class="w-64">
				<vs-dropdown-item @click.stop="goToConfig">
					<vx-tooltip delay=".1s" :text="$t('CompanyConfigCrud')" position="bottom">
						<div class="flex items-center mt-2">
							<feather-icon icon="SettingsIcon" svgClasses="w-5 h-5 hover:text-success stroke-current" />
							<span class="ml-2">{{ $t("Setting.Setting") }}</span>
						</div>
					</vx-tooltip>
				</vs-dropdown-item>
				<vs-dropdown-group :vs-label="''">
					<vs-dropdown-item @click="handleOption('EXPORT_ALL')">
						<div class="flex items-center hover:text-primary stroke-current">
							<feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-success stroke-current" />
							<span class="ml-2">{{ $t("ExportAll") }}</span>
						</div>
					</vs-dropdown-item>
				</vs-dropdown-group>
			</vs-dropdown-menu>
		</vs-dropdown>
	</vs-navbar>
</template>

<script>
export default {
	props: {
		handleOption: {
			type: Function,
			required: true,
		},
		selected: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {};
	},
	methods: {
		goToConfig() {
			this.$router
				.push({
					name: "app-setting",
					params: {config_type: "LIST"},
				})
				.catch(() => {});
		},
	},
};
</script>
